// Mock данные для тестирования, если API недоступен
export const mockArticles = [
    {
        _id: '1',
        title: 'Одиночество в толпе: экзистенциальная данность или повод для терапии',
        slug: 'odinochestvo-v-tolpe-ekzistentsialnaya-dannost-ili-povod-dlya-terapii',
        createdAt: '2024-01-15T10:00:00Z',
        updatedAt: '2024-01-15T10:00:00Z',
        published: true
    },
    {
        _id: '2', 
        title: 'Тревожность: как отличить норму от патологии',
        slug: 'trevozhnost-kak-otlichit-normu-ot-patologii',
        createdAt: '2024-01-10T15:30:00Z',
        updatedAt: '2024-01-10T15:30:00Z',
        published: true
    },
    {
        _id: '3',
        title: 'Депрессия: не просто плохое настроение',
        slug: 'depresiya-ne-prosto-plohoe-nastroenie',
        createdAt: '2024-01-05T09:15:00Z',
        updatedAt: '2024-01-05T09:15:00Z',
        published: true
    }
];

export const mockAPIResponse = {
    posts: mockArticles,
    currentPage: 1,
    totalPages: 1,
    totalPosts: mockArticles.length
};
